import Generator from './generator';

export default class EnrolledActualCurveGenerator extends Generator {
  static _lineChartConfig = {
    yAxis: 1,
    type: 'line',
    dashStyle: null,
    showInLegend: true,
    enableMouseTracking: true,
    customTags: ['enrolled-actual'],
  };

  getEnrolledActualSeriesData(objectArray) {
    const seriesData = this._getSeriesData(objectArray, 'actualEnrolledCum');

    return seriesData;
  }

  getSeries(objectArray) {
    const lineSeriesData = this.getEnrolledActualSeriesData(objectArray);

    const enrolledActualSeries = {
      id: 'enrolled-actual',
      name: 'Enrollment (Actual)',
      data: lineSeriesData,
      color: '#771959',
      zIndex: 3,
      marker: { enabled: lineSeriesData.length === 1 },
      ...EnrolledActualCurveGenerator._lineChartConfig,
    };

    return [enrolledActualSeries];
  }
}
